import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from '@metarouter-private/mr-mui';

import useIntegrationNamesById from './useIntegrationNamesById';
import DeployedIntegrationsLoadingIndicator from './DeployedIntegrationsLoadingIndicator';
import DeployedIntegrationsList from './DeployedIntegrationsList';

export default function ConfirmDeleteIntegrationsList({
  loadingIntegrations,
  deployedIntegrations = [],
  integrationsLoadError,
}) {
  const integrationNamesById = useIntegrationNamesById();

  if (loadingIntegrations) {
    return <DeployedIntegrationsLoadingIndicator loading={loadingIntegrations} />;
  }

  if (integrationsLoadError) {
    return <Alert severity="error">Error loading integrations</Alert>;
  }

  if (!deployedIntegrations.length) {
    return <Alert severity="info">This pipeline is not currently deployed</Alert>;
  }

  return (
    <DeployedIntegrationsList deployedIntegrations={deployedIntegrations} integrationNamesById={integrationNamesById} />
  );
}

ConfirmDeleteIntegrationsList.propTypes = {
  loadingIntegrations: PropTypes.bool,
  deployedIntegrations: PropTypes.array,
  integrationsLoadError: PropTypes.object,
};
